import {  Get_Credentials } from './thunk';

import { createSlice } from '@reduxjs/toolkit';

const CredentialSlice = createSlice({
    name: 'Credential',
    initialState: {
        data: null,
        loading: false,
        error: null,
        success: false,
    },
    reducers: {
        resetCredentialState: (state) => {
            state.loading = false;
            state.data = null;
            state.error = null;
            state.success = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(Get_Credentials.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(Get_Credentials.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.success = true;
            })
            .addCase(Get_Credentials.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetSignUpState } = CredentialSlice.actions;
export default CredentialSlice.reducer;
